<template>
   <div class="footer">
      <div
         class="flex item-center justify-center border-slate-200 border-t backdrop-blur-md bg-white/25">
         <div class="text-darkblue py-2.5 font-semibold">
            Copyright &copy; 2023 created by yuz
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "FooterComponent",
};
</script>

<style></style>
